const Index = () => import(/* webpackChunkName: "manager" */ './Index');
const Personal = () => import(/* webpackChunkName: "personal" */ './Personal');

export default {
  routes: [
    {
      path: '/ctra/index',
      name: 'ctra_index',
      component: Index
    },
    {
      path: '/ctra/personal',
      name: 'ctra_personal',
      component: Personal
    }
  ]
}
